import { render, staticRenderFns } from "./PageNine.vue?vue&type=template&id=49e0cd8a&scoped=true"
import script from "./PageNine.vue?vue&type=script&lang=js"
export * from "./PageNine.vue?vue&type=script&lang=js"
import style0 from "./PageNine.vue?vue&type=style&index=0&id=49e0cd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e0cd8a",
  null
  
)

export default component.exports